import { render, staticRenderFns } from "./ViewVideos.vue?vue&type=template&id=7ad4e203&scoped=true"
import script from "./ViewVideos.vue?vue&type=script&lang=js"
export * from "./ViewVideos.vue?vue&type=script&lang=js"
import style0 from "./ViewVideos.vue?vue&type=style&index=0&id=7ad4e203&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ad4e203",
  null
  
)

export default component.exports